/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_Buttons_TitleInputs */

const es_walkthrough_sidebar_buttons_title = /** @type {(inputs: Walkthrough_Sidebar_Buttons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones Rápidas`)
};

const en_walkthrough_sidebar_buttons_title = /** @type {(inputs: Walkthrough_Sidebar_Buttons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Actions`)
};

/**
* | output |
* | --- |
* | "Quick Actions" |
*
* @param {Walkthrough_Sidebar_Buttons_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_buttons_title = /** @type {((inputs?: Walkthrough_Sidebar_Buttons_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_Buttons_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_buttons_title(inputs)
	return en_walkthrough_sidebar_buttons_title(inputs)
});
export { walkthrough_sidebar_buttons_title as "walkthrough.sidebar_buttons_title" }